//import { RouteType } from '@/main/menu/constants';
import { NAME as name } from './constants';
import { WmsAdmin } from './wmsAdmin';
import { WmsReception } from './wmsReception';
import { WmsParking } from './wmsParking';
import { WmsDashboard } from './wmsDashboard';
import { WmsServiceAdvisor } from './wmsServiceAdvisor';
import { WmsJobController } from './wmsJobController';
import { WmsTechnician } from './wmsTechnician';
import { WmsFinalInspection } from './wmsFinalInspector';
import { WmsWashingLabor } from './wmsWashingLabor';
import { WmsVasSupervisor } from './WmsVasSupervisor';
import { WmsSecurityguard } from './wmsSecurityguard';

export const menu = {
	name,
	orderAlphabetically: false,
	list: [
		{ name: 'WmsDashboard', route: WmsDashboard.name },
		{ name: 'WmsReception', route: WmsReception.name },
		{ name: 'WmsParking', route: WmsParking.name },
		{ name: 'WmsAdmin', route: WmsAdmin.name },
		{ name: 'WmsServiceAdvisor', route: WmsServiceAdvisor.name },
		{ name: 'WmsJobController', route: WmsJobController.name },
		{ name: 'WmsTechnician', route: WmsTechnician.name },
		{ name: 'WmsFinalInspection', route: WmsFinalInspection.name },
		{ name: 'WmsWashingLabor', route: WmsWashingLabor.name },
		{ name: 'WmsVasSupervisor', route: WmsVasSupervisor.name },
		{ name: 'WmsSecurityguard', route: WmsSecurityguard.name },
	],
};
